import { AccountantService, ClientService } from "../../../../services";
import {
	BackdropCircularProgress,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
} from "@websential/cosmic-v20";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import {
	EMPLOYEE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	formatAmountCommaSeperator,
	formatDate,
	sortDDLByLabel,
	useNavigateToLogout,
	useRemoveQueriesOnUnmount
} from "../../../../common/Common";
import {
	setSelectedAccountant,
	setSelectedAccountantName,
	setSelectedActivityLogActions,
	setSelectedClient,
	setSelectedClientName,
	setSelectedStickyNavBar,
} from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { IAppState } from "../../../../store/reducers";
import { IDropDownListResponse } from "../../../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../../../models";
import { ReadyTransacitonsDataGrid } from "./ReadyTransacitonsDataGrid";
import { ReadyTransacitonsHeader } from "./ReadyTransacitonsHeader"
import { ReadyTransacitonsToolbar } from "./ReadyTransacitonsToolbar";
import { TransactionsServices } from "../../../../services/DirectDeposit/TransactionsServices";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { setTransactionsHeaders } from "../../../../store/actions/transactionsHeadersActions";
import { useNavigate } from "react-router-dom";

export interface IReadyTransacitonsSetupPage { }
const READY_TRANSACTIONS_QUERY_KEY = "ready-transactions";
const CLIENT_DDL_DATA_QUERY_KEY = "client-ddl-data-record";
const ACCOUNTANT_DDL_DATA_QUERY_KEY = "accountant-ddl-data-record";

const useReadyTransacitons = (
	runGetListAPICall: boolean,
	accountant: string,
	client: string,
	clientType: string | number,
	type: string,
	transactionMethod: string | number,
	dateAppliesOn: string | number,
	startDate: string | null,
	endDate: string | null,
	params: IGetListRequest,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: [
			READY_TRANSACTIONS_QUERY_KEY,
			runGetListAPICall,
			accountant,
			client,
			clientType,
			type,
			transactionMethod,
			dateAppliesOn,
			params,
		],
		queryFn: () =>
			TransactionsServices.getDirectDepositList(
				runGetListAPICall,
				900,
				accountant,
				client,
				clientType,
				type,
				transactionMethod,
				dateAppliesOn,
				startDate,
				endDate,
				params,
				navigateToLogout
			),
		refetchOnWindowFocus: false,
	});

const useGetAccountantDDLItemsItems = () =>
	useQuery({
		queryKey: [ACCOUNTANT_DDL_DATA_QUERY_KEY],
		queryFn: (data) => {
			return AccountantService.getGetAccountantDDL();
		},
		refetchOnWindowFocus: false,
	});
const useGetClientsDDLItems = (accountantId: string) =>
	useQuery({
		queryKey: [CLIENT_DDL_DATA_QUERY_KEY, accountantId],
		queryFn: (data) => {
			return ClientService.getGetClientDDL(accountantId);
		},
		refetchOnWindowFocus: false,
	});


export const ReadyTransacitons: React.FC<IReadyTransacitonsSetupPage> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openWireTransferWarningDialoage, setOpenWireTransferWarningDialoage] = useState(false);
	const [openWireTransferWarningDialoageData, setOpenWireTransferWarningDialoageData] = useState<any>(null);
	const [openWireTransferWarningDialoageDataForSave, setOpenWireTransferWarningDialoageDataForSave] = useState<any>(null);
	const [buttonTag, setButtonTag] = useState<any>(null);
	const [dialogButtonLabel, setDialogButtonLabel] = useState("");
	const [dialogContent, setDialogContent] = useState("");

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRows, setSelectedRows] = useState([]);
	const [selectedSubRows, setSelectedSubRows] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [accountantId, setAccountantId] = useState("all");
	const [readyTransacitonsData, setReadyTransacitonsData] =
		useState<any>(undefined);
	const [runGetListAPICall, setRunGetListAPICall] =
		useState<any>(true);

	const formMethods = useForm<any>({
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	let {
		accountantStored,
		clientStored,
		clientTypeStored,
		typeStored,
		transactionMethodStored,
		dateAppliesOnStored,
		startDateStored,
		endDateStored,
	} = useSelector((state: IAppState) => {
		return {
			accountantStored: state.transactionsHeaders.accountant,
			clientStored: state.transactionsHeaders.client,
			clientTypeStored: state.transactionsHeaders.clientType,
			typeStored: state.transactionsHeaders.type,
			transactionMethodStored: state.transactionsHeaders.transactionMethod,
			dateAppliesOnStored: state.transactionsHeaders.dateAppliesOn,
			startDateStored: state.transactionsHeaders.startDate,
			endDateStored: state.transactionsHeaders.endDate,
		};
	});
	const transactionsHeaders = useSelector((state: IAppState) => state.transactionsHeaders);




	const accountant = formMethods.getValues("accountant");
	const client = formMethods.getValues("client");
	const clientType = formMethods.getValues("clientType");
	const type = formMethods.getValues("type");
	const transactionMethod = formMethods.getValues("transactionMethod");
	const dateAppliesOn = formMethods.getValues("dateAppliesOn");
	const startDate = formMethods.getValues("startDate");
	const endDate = formMethods.getValues("endDate");

	useEffect(() => {
		if (accountantStored && accountantStored !== accountant) {
			formMethods.setValue('accountant', accountantStored)
		}
		if (clientStored && clientStored !== client) {
			formMethods.setValue('client', clientStored)
		}
		if (clientTypeStored && clientTypeStored !== clientType) {
			formMethods.setValue('clientType', clientTypeStored)
		}
		if (typeStored && typeStored !== type) {
			formMethods.setValue('type', typeStored)
		}
		if (dateAppliesOnStored && dateAppliesOnStored !== dateAppliesOn) {
			formMethods.setValue('dateAppliesOn', dateAppliesOnStored)
		}
		if (transactionMethodStored && transactionMethodStored !== transactionMethod) {
			formMethods.setValue('transactionMethod', transactionMethodStored)
		}
		if (startDateStored && startDateStored !== startDate) {
			let date = new Date(startDateStored)
			formMethods.setValue('startDate', date)
		}
		if (endDateStored && endDateStored !== endDate) {
			let date = new Date(endDateStored)
			formMethods.setValue('endDate', date)
		}
		// formMethods.setValue('accountant', accountantStored)
		// formMethods.setValue('client', clientStored)
		// formMethods.setValue('clientType', clientTypeStored)
		// formMethods.setValue('type', typeStored)
		// formMethods.setValue('dateAppliesOn', dateAppliesOnStored)
		// formMethods.setValue('startDate', startDateStored)
		// formMethods.setValue('endDate', endDateStored)
	}, [accountantStored, clientStored, clientTypeStored, typeStored, transactionMethodStored, dateAppliesOnStored, startDateStored, endDateStored])






	// const { isPending, data } = useReadyTransacitons(
	// 	runGetListAPICall,
	// 	accountant && accountant,
	// 	client && client,
	// 	clientType && clientType,
	// 	type && type,
	// 	dateAppliesOn && dateAppliesOn,
	// 	formatDate(startDate),
	// 	formatDate(endDate),
	// 	queryParams,
	// 	navigateToLogout
	// );
	const { isPending, data } = useReadyTransacitons(
		runGetListAPICall,
		accountantStored && accountantStored,
		clientStored && clientStored,
		clientTypeStored && clientTypeStored,
		typeStored && typeStored,
		transactionMethodStored && transactionMethodStored,
		dateAppliesOnStored && dateAppliesOnStored,
		startDateStored && startDateStored,
		endDateStored && endDateStored,
		queryParams,
		navigateToLogout
	);
	const ReadyTransacitonsList: any | null = data;

	useEffect(() => {
		if (ReadyTransacitonsList) {
			setReadyTransacitonsData(ReadyTransacitonsList);
		}
	}, [ReadyTransacitonsList]);

	const { isPending: isProcessing, mutate: processReadyTransactions } =
		useMutation({
			mutationFn: TransactionsServices.updateDirectDepositForCollections,
			onSuccess: (res: IServerError | IResponse | any) => {

				if (res.status === 200) {
					// if (instanceOfIDepartmentsResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					// let path = `/company/departments/setup/${res.data.id}`;
					// navigate(path);
					// return Promise.all([
					// queryClient.invalidateQueries({
					// 	queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
					// }),
					// queryClient.invalidateQueries({
					// 	queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
					// }),
					// ]);
					queryClient.invalidateQueries({ queryKey: [READY_TRANSACTIONS_QUERY_KEY] })
				} else if (res.status === 201) {
					// if (instanceOfIDepartmentsResponse(res)) {
					// setEditRecordId(res.id);
					// queryClient.invalidateQueries(SINGLE_RECORD_DATA_QUERY_KEY);
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					// let path = `/company/departments/setup/${res.data.id}`;
					// navigate(path);
					// setEditRecordId(res.data.id);
					// return Promise.all([
					// queryClient.invalidateQueries({
					// 	queryKey: [DEPARTMENTS_LIST_DATA_QUERY_KEY],
					// }),
					// queryClient.invalidateQueries({
					// 	queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
					// }),
					// ]);
					queryClient.invalidateQueries({ queryKey: [READY_TRANSACTIONS_QUERY_KEY] })
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingAccountantDDLItemsItems, data: accountantDDL } =
		useGetAccountantDDLItemsItems();
	const { isPending: isPendingClientsDDLItems, data: clientsDDL } =
		useGetClientsDDLItems(accountantId);

	//   after click apply button api calls with updated values and update employee report data
	// const ReadyTransacitonsDataAPICall = (
	// 	clientIdStore: string,
	// ) => {
	// 	const fetchData = async () => {
	// 		setIsLoading(true);
	// 		setQueryParams({
	// 			search_query: "",
	// 			order_by: "firstName",
	// 			order_direction: "asc",
	// 			page: 1,
	// 			size: 25,
	// 		});
	// 		try {
	// 			const response: any = await ReportsService.getReadyTransacitons(
	// 				clientIdStore,
	// 				{
	// 					search_query: "",
	// 					order_by: "firstName",
	// 					order_direction: "asc",
	// 					page: 1,
	// 					size: 25,
	// 				},
	// 				navigateToLogout
	// 			);

	// 			if (response) {
	// 				setReadyTransacitonsData(response);
	// 			}
	// 		} catch {
	// 		} finally {
	// 			setIsLoading(false);
	// 		}
	// 	};
	// 	fetchData();
	// };


	const accountantDDLItems = useMemo(() => {
		if (accountantDDL) {
			if (
				accountantDDL &&
				Array.isArray(accountantDDL)
			) {
				let resources: IDropDownListResponse[] =
					sortDDLByLabel(accountantDDL).map(
						(resourceItem: IDropDownListResponse) => ({
							// id: resourceItem.id,
							label: resourceItem.label,
							value: resourceItem.value,
						})
					);

				resources.unshift({
					label: "All",
					value: "all",
				});

				return resources;
			}
			return [];
		}
	}, [accountantDDL]);

	const clientsDDLItems = useMemo(() => {
		if (clientsDDL) {
			if (
				clientsDDL &&
				Array.isArray(clientsDDL)
			) {
				let resources: IDropDownListResponse[] =
					sortDDLByLabel(clientsDDL).map(
						(resourceItem: IDropDownListResponse) => ({
							// id: resourceItem.id,
							label: resourceItem.label,
							value: resourceItem.value,
						})
					);

				resources.unshift({
					label: "All",
					value: "all",
				});

				return resources;
			}
			return [];
		}
	}, [clientsDDL]);

	const onAccountantSelectionChangeHandler = (event: any) => {
		setRunGetListAPICall(false)
		setAccountantId(event.value)
		dispatch(setTransactionsHeaders({ accountant: event.value, client: "all" }));
		formMethods.setValue('client', 'all')
	}

	//   after click apply button api calls with updated values and update employee report data
	const readyTransacitonsDataAPICall = (
		accountant: string,
		client: string,
		clientType: string,
		type: string,
		transactionMethod: string | number,
		dateAppliesOn: string,
		startDate: string | null,
		endDate: string | null,
	) => {
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const response: any = await TransactionsServices.getDirectDepositList(
					true,
					900,
					accountant,
					client,
					clientType,
					type,
					transactionMethod,
					dateAppliesOn,
					formatDate(startDate),
					formatDate(endDate),
					queryParams,
					navigateToLogout
				);

				if (response) {
					setReadyTransacitonsData(response);
				}
			} catch {
			} finally {
				setIsLoading(false);
			}
		};
		fetchData();
	};

	const onClickHandler = async (clickedRow: any) => {
		setIsLoading(true);
		try {
			const accountantDetails = await AccountantService.getById(
				clickedRow.accountantId,
				navigateToLogout
			);

			if (accountantDetails && accountantDetails.id) {
				dispatch(setSelectedAccountant({ id: accountantDetails.id }));
				dispatch(setSelectedAccountant(accountantDetails));
				dispatch(setSelectedAccountantName({ accTitle: accountantDetails.accTitle }));

				const clientDetails = await ClientService.getById(clickedRow.clientId, navigateToLogout);

				if (clientDetails && clientDetails.id) {
					dispatch(
						setSelectedClient({
							...clientDetails,
							superUserFieldsShownInClientSetup: true,
						})
					);
					dispatch(setSelectedClientName({ clientName: clientDetails.legalName }));
					navigate("/clients/dashboard");
				}
			} else {
				const response = await ClientService.getById(clickedRow.clientId, navigateToLogout);

				if (response && response.id) {
					dispatch(setSelectedClient(response));
					navigate("/clients/dashboard");
				}
			}
		} catch (error) {
			// handle/log error as needed
		} finally {
			setIsLoading(false);
		}
	};

	const onSubmit = (values: any) => {
		readyTransacitonsDataAPICall(
			values.accountant,
			values.client,
			values.clientType,
			values.type,
			values.transactionMethod,
			values.dateAppliesOn,
			values.startDate,
			values.endDate,
		);
	};

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
		setRunGetListAPICall(true)
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["employee-report"]);

	const upadtedReadyTransactionsListItems = useMemo(() => {
		return (
			readyTransacitonsData &&
			readyTransacitonsData.items &&
			readyTransacitonsData?.items.map((item: any) => ({
				...item,
				clientName: (
					<span
						// to={`/clients/dashboard`}
						className="no-underline"
						style={{ color: theme.palette.primary.light, cursor: "pointer" }}
						onClick={() => onClickHandler(item)}
					>
						{item.clientName}
					</span>
				),
				orders: item.orders &&
					item.orders.map((item: any) => ({
						...item,
						clientName: (
							<span
								// to={`/clients/dashboard`}
								className="no-underline"
								style={{ color: theme.palette.primary.light, cursor: "pointer" }}
								onClick={() => onClickHandler(item)}
							>
								{item.clientName}
							</span>
						),
					}))
			}))
		);
	}, [readyTransacitonsData]);



	// const updatedTotalSelectedRows = (rows: any, subRows: any) => {
	// 	const rowsWhichParentNotSelected = rows && rows.reduce((acc: any, parent: any) => {
	// 		const parentOrderIds = parent.orders.map((o: any) => o.id);

	// 		const allOrdersPresent = parentOrderIds.every((orderId: any) =>
	// 			acc.some((nk: any) => nk.id === orderId)
	// 		);

	// 		if (allOrdersPresent) {
	// 			// remove all matching children
	// 			return acc.filter((nk: any) => !parentOrderIds.includes(nk.id));
	// 		}

	// 		return acc;
	// 	}, subRows);

	// 	let rowsWhichParentNotSelectedIds = rowsWhichParentNotSelected.map((item: any) => item.id);
	// 	let selectedRowsIds = selectedRows.map((item: any) => item.id);
	// 	let totalRowsSelected = [...rowsWhichParentNotSelected, ...selectedRows]
	// 	let totalRowsSelectedIds = [...rowsWhichParentNotSelectedIds, ...selectedRowsIds]

	// 	return totalRowsSelected
	// }

	const selectedRowsWhichDontHaveChilds = selectedRows.filter((item: any) => item.orders.length === 0)
	const updatedTotalSelectedRowsWithChildsAndAlone = [...selectedRowsWhichDontHaveChilds, ...selectedSubRows]


	const onStartProcessingButtonClickedHandler = () => {
		// const totalSelectedRows = updatedTotalSelectedRows(upadtedReadyTransactionsListItems, selectedSubRows)

		// if (selectedSubRows.length !== 0) {

	
		if (updatedTotalSelectedRowsWithChildsAndAlone.length !== 0) {
			setDialogOpen(true)
			setButtonTag("proceed")
			setDialogButtonLabel("Proceed")
			// setDialogContent(`Are you sure you want to process (${selectedSubRows.length}) selected ${selectedSubRows.length === 1 ? 'record' : 'records'}?`)
			setDialogContent(`Are you sure you want to process (${updatedTotalSelectedRowsWithChildsAndAlone.length}) selected ${updatedTotalSelectedRowsWithChildsAndAlone.length === 1 ? 'record' : 'records'}?`)
		} else {
			setSnackbarData({
				open: true,
				message: "Please select at least one row to process!",
				severity: "error"
			})
		}
	}
	const onDeleteButtonClickedHandler = () => {
		// const totalSelectedRows = updatedTotalSelectedRows(upadtedReadyTransactionsListItems, selectedSubRows)

		if (selectedSubRows.length !== 0) {
			setDialogOpen(true)
			setButtonTag("delete")
			setDialogButtonLabel("Delete")
			setDialogContent(`Are you sure you want to delete (${selectedSubRows.length}) selected ${selectedSubRows.length === 1 ? 'record' : 'records'}?`)
		} else {
			setSnackbarData({
				open: true,
				message: "Please select at least one row to delete!",
				severity: "error"
			})
		}
	}
	const onPermanentDeleteButtonClickedHandler = () => {
		// const totalSelectedRows = updatedTotalSelectedRows(upadtedReadyTransactionsListItems, selectedSubRows)

		if (selectedSubRows.length !== 0) {
			setDialogOpen(true)
			setButtonTag("permanent-delete")
			setDialogButtonLabel("Permanent Delete")
			setDialogContent(`Are you sure you want to Permanent Delete (${selectedSubRows.length}) selected ${selectedSubRows.length === 1 ? 'record' : 'records'}?`)
		} else {
			setSnackbarData({
				open: true,
				message: "Please select at least one row to permanent delete!",
				severity: "error"
			})
		}
	}
	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseWireTransferWarningDialoageHandler = () => {
		setOpenWireTransferWarningDialoage(false);
		setOpenWireTransferWarningDialoageData(null)
		setOpenWireTransferWarningDialoageDataForSave(null)
	};

	const onConfirmWireTransferWarningDialoageSubmit = () => {
	
		const updatePayloadData =
			openWireTransferWarningDialoageDataForSave.map((item: any) => ({
				...item,
				lastTab: 900,
				fromLastTabOn: 700,
				// this line add after making clientname clickable 
				clientName: item.clientName.props ? item.clientName.props.children : item.clientName
			}));
		processReadyTransactions(updatePayloadData)
		setOpenWireTransferWarningDialoage(false);
		setOpenWireTransferWarningDialoageData(null)
		setOpenWireTransferWarningDialoageDataForSave(null)
	}
	const dialogButtonClickedHandler = async (tag: string | null) => {
		if (buttonTag !== null && buttonTag === 'proceed') {
			// const totalSelectedRows = updatedTotalSelectedRows(upadtedReadyTransactionsListItems, selectedSubRows)
			// processReadyTransactions(selectedSubRows)
			const updatePayloadData =
				updatedTotalSelectedRowsWithChildsAndAlone.map((item: any) => ({
					...item,
					lastTab: 900,
					fromLastTabOn: 700,
					// this line add after making clientname clickable 
					clientName: item.clientName.props ? item.clientName.props.children : item.clientName
					// transactionMethod: item.transactionId === 1 ? 200 : item.transactionId === 2 ? 200 : 100,
					// amount: item.transactionId === 1 ? 152.55 : item.transactionId === 2 ? 3518.34 : item.amount,
					// accumulatedAmount: item.transactionId === 2 ? 90.42 : item.transactionId === 1 ? -27796.38 : item.amount
				}));
		
			const totalWithWireMethods = updatePayloadData.filter(
				(x: any) => x.transactionMethod === 200
				// && Number(x.amount) > Number(x.accumulatedAmount)
			);
			
			if (totalWithWireMethods && totalWithWireMethods.length) {

				(async () => {
					const wireIds = Array.from(new Set(totalWithWireMethods.map((x: any) => x.clientId)));
					
					try {
						const response: any =
							await TransactionsServices.getClientsAccumulatedAmounts(wireIds);

						
						if (response) {
							// Step 1: Sum all amounts per clientId from items
							const clientAmountMap = totalWithWireMethods.reduce((acc: any, item: any) => {
								acc[item.clientId] = (acc[item.clientId] || 0) + item.amount;
								return acc;
							}, {});
							// { "6a0b02877fd71cc0b1b4c547": 26185.43 }  (152.55 + 3518.34 + 22514.54)

							// Step 2: Add availableAmount to data
							const updatedData = response.map((d: any) => ({
								...d,
								availableAmount: clientAmountMap[d.clientId] || 0
							}));

							

							const acceptableWithWireMethods = updatedData.filter(
								(x: any) => Number(x.availableAmount) > Number(x.accumulatedAmount)
							);

							if (acceptableWithWireMethods && acceptableWithWireMethods.length) {
								const remainingItems = updatePayloadData.filter(
									(x: any) => !acceptableWithWireMethods.some((wire: any) => wire.clientId === x.clientId)
								);
								const itemsWithWrongData = updatePayloadData.filter(
									(x: any) => acceptableWithWireMethods.some((wire: any) => wire.clientId === x.clientId)
								);

								
								if (remainingItems && remainingItems.length) {
									(async () => {
										try {
											const response: any =
												await TransactionsServices.updateDirectDepositForCollections(remainingItems);
											setDialogOpen(false)
											setOpenWireTransferWarningDialoageData(acceptableWithWireMethods)
											setOpenWireTransferWarningDialoageDataForSave(itemsWithWrongData)
											setOpenWireTransferWarningDialoage(true)
										} catch { }
									})();
								} else {
									setDialogOpen(false)
									setOpenWireTransferWarningDialoageData(acceptableWithWireMethods)
									setOpenWireTransferWarningDialoageDataForSave(itemsWithWrongData)
									setOpenWireTransferWarningDialoage(true)
								}
							}


							// setDialogOpen(false)
							// setOpenWireTransferWarningDialoageData(updatedItems)
							// setOpenWireTransferWarningDialoage(true)
						}
					} catch { }
				})();


				// const remainingItems = updatePayloadData.filter(
				// 	(x: any) => !totalWithWireMethods.some((wire: any) => wire.id === x.id)
				// );
			

				// if (remainingItems && remainingItems.length) {
				// 	(async () => {
				// 		try {
				// 			const response: any =
				// 				await TransactionsServices.updateDirectDepositForCollections(remainingItems);
				// 			setDialogOpen(false)
				// 			setOpenWireTransferWarningDialoageData(totalWithWireMethods)
				// 			setOpenWireTransferWarningDialoage(true)
				// 		} catch { }
				// 	})();
				// } else {
				// 	setDialogOpen(false)
				// 	setOpenWireTransferWarningDialoageData(totalWithWireMethods)
				// 	setOpenWireTransferWarningDialoage(true)
				// }
			} else {
				processReadyTransactions(updatePayloadData)
				setDialogOpen(false)
			}
		} else if (buttonTag !== null && buttonTag === 'delete') {
			// const totalSelectedRows = updatedTotalSelectedRows(upadtedReadyTransactionsListItems, selectedSubRows);
			(async () => {
				try {
					setIsLoading(true)
					const response: any =
						await TransactionsServices.deleteReadyTransactions(selectedSubRows);
					queryClient.invalidateQueries({ queryKey: [READY_TRANSACTIONS_QUERY_KEY] })
				} catch { } finally { setIsLoading(false) }
			})();
		} else if (buttonTag !== null && buttonTag === 'permanent-delete') {
			// const totalSelectedRows = updatedTotalSelectedRows(upadtedReadyTransactionsListItems, selectedSubRows);
			(async () => {
				try {
					setIsLoading(true)
					const response: any =
						await TransactionsServices.deletePermanentReadyTransactions(selectedSubRows);
					queryClient.invalidateQueries({ queryKey: [READY_TRANSACTIONS_QUERY_KEY] })
				} catch { } finally { setIsLoading(false) }
			})();
		}
	}
	const expandedLabels = ["Transactions", "Collection"];
	const expandedCRAOrSetupItem = "Ready";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Collection" &&
				item.label === expandedCRAOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedCRAOrSetupItem && "/direct-deposit/transactions/ready",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);



	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"Ready"}
			</div>

			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<ReadyTransacitonsHeader
						clientsDDL={clientsDDLItems}
						accountantDDL={accountantDDLItems}
						onAccountantSelectionChangeHandler={onAccountantSelectionChangeHandler}
						setStateRunGetListAPICall={(value: boolean) => setRunGetListAPICall(value)} />
				</form>
			</FormProvider>

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending ||
						isLoading ||
						isPendingClientsDDLItems ||
						isProcessing
					}
					testId="ready-transactions"
				/>


				<ReadyTransacitonsDataGrid
					columns={
						readyTransacitonsData?.headerColumns
							? readyTransacitonsData.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
					}
					rows={
						readyTransacitonsData && upadtedReadyTransactionsListItems
							? upadtedReadyTransactionsListItems
							: []
						// readyTransacitonsData && readyTransacitonsData.items
						// 	? readyTransacitonsData.items
						// 	: []
					}
					showIndexColumn={true}
					showChecboxColumn={true}
					showSettingColumn={false}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						readyTransacitonsData && readyTransacitonsData.total
							? readyTransacitonsData.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					searchFieldPlaceholder={"Search..."}
					showRowExpandedView={true}
					selectedRows={(value: any) => setSelectedRows(value)}
					selectedSubRows={(value: any) => setSelectedSubRows(value)}
				/>
				{readyTransacitonsData && readyTransacitonsData.items && readyTransacitonsData.items.length > 0 && (
					<ReadyTransacitonsToolbar
						onStartProcessingButtonClickedHandler={onStartProcessingButtonClickedHandler}
						onDeleteButtonClickedHandler={onDeleteButtonClickedHandler}
						onPermanentDeleteButtonClickedHandler={onPermanentDeleteButtonClickedHandler}
					/>
				)}
			</Grid>

			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseHandler}
				open={openDialog}
				dialogContent={dialogContent}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label={dialogButtonLabel}
							severity={buttonTag === 'proceed' ? EnhancedButtonPrimeReactSeverity.Success : EnhancedButtonPrimeReactSeverity.Danger}
							raised
							onClickHandler={() => dialogButtonClickedHandler(buttonTag)}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>



			{/* Wire Transfer Warning Dialoage */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseWireTransferWarningDialoageHandler}
				open={openWireTransferWarningDialoage}
				dialogContent={
					<Box>
						<Typography variant="body2" sx={{ mb: 2 }}>
							Total amount of wire transfer companies exceed available balance. <br />
							Click Ok to proceed transactions
						</Typography>
						{openWireTransferWarningDialoageData && openWireTransferWarningDialoageData.map((item: any) => (
							<Typography variant="body2" sx={{ mb: 2 }}>
								{item.clientName} <br />
								<Box sx={{ display: "flex", justifyContent: "space-between" }}>
									<Typography sx={{ fontSize: ".875rem" }}>Selected Transactions Amount: <span style={{ fontWeight: "bold" }}>{formatAmountCommaSeperator(item.availableAmount)}</span></Typography>
									<Typography sx={{ fontSize: ".875rem" }}>Available: <span style={{ fontWeight: "bold" }}>{formatAmountCommaSeperator(item.accumulatedAmount)}</span></Typography>
								</Box>
								{/* Selected Transactions Amount: {formatAmountCommaSeperator(item.amount)}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Available: {formatAmountCommaSeperator(item.accumulatedAmount)} <br /> */}
								Difference: <span style={{ fontWeight: "bold" }}>{formatAmountCommaSeperator(item.availableAmount - item.accumulatedAmount)}</span>
							</Typography>
						))}
					</Box>
				}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseWireTransferWarningDialoageHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Ok"
							severity="success"
							raised
							onClickHandler={onConfirmWireTransferWarningDialoageSubmit}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
